var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00133705 0.940571C0.00102425 0.739983 0.0567017 0.54559 0.158703 0.391137C0.274707 0.215569 0.441618 0.105132 0.622607 0.0841946C0.803596 0.0632568 0.983788 0.133539 1.12342 0.279533L4.79071 4.12557L8.46485 0.416891C8.6062 0.272862 8.78748 0.205472 8.96854 0.229641C9.14961 0.253811 9.31553 0.367546 9.42957 0.545665C9.55549 0.725233 9.61599 0.962572 9.59651 1.2005C9.57703 1.43843 9.47933 1.65537 9.32694 1.79906L5.22176 5.94557C4.96929 6.20597 4.6053 6.20597 4.35283 5.94557L0.247648 1.65312C0.0797148 1.47845 -0.0117769 1.21377 0.00133705 0.940571Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.295690228aa561962e84b60fc21c204b.svg";
export { ForwardRef as ReactComponent };